<template>
	<div>
		<a-row>
				<a-row class="banner-title">
					<a-col :span="20"><h3>商会创业互助列表</h3></a-col>
					<a-col :span="4" style="padding-bottom: 15px;" ><a-button type="danger"  icon="plus-square" @click="showAddStyleModal">发布创业互助</a-button></a-col>
				</a-row>
				<!-- <a-card hoverable style="width: 300px;float: left; margin: 10px;" :key="index"  v-for="(item,index) in helpList">
					<img
					alt="example"
					:src="item.img[0]"
					slot="cover"
					/>
					<template class="ant-card-actions" slot="actions">
						<a-icon type="edit"  @click="showCommodityModal"/>
						<a-icon type="delete" @click="deleteDynamic(item.id)"/>
						<a-icon type="ellipsis" />
					</template>
					<a-card-meta :title="item.title"  :description="item.content">
						<a-avatar
						slot="avatar"
						:src="item.img[0]"
						/>
					</a-card-meta>
				</a-card> -->
		</a-row>
		
		
		<a-list style="width: 1000px;" item-layout="vertical" size="large" :pagination="pagination" :data-source="helpList">
			<div slot="footer">
				<b>帝全</b>
				创业互助
			</div>
			<a-list-item slot="renderItem" :key="item.title" slot-scope="item, index">
				<template slot="actions">
					<a-popconfirm title="将删除该条创业互助,是否删除？" @confirm="deleteDynamic(item.id)" @cancel="cancel" okText="删除" cancelText="取消">
						<a-button type="danger" size="small">删除</a-button>
					</a-popconfirm>
					<span>{{ item.addTime }}</span>
				</template>
		
				<img 
				style="max-width: 100px; max-height: 100px;"
		    slot="extra"
		    width="272"
		    alt="logo"
		    :src="item.img[0]"
		  />
				<a-list-item-meta description="">
					<a slot="title">{{ item.title }}</a>
					<a-avatar slot="avatar" src="http://cdn.diqwl.com/store_banner_inform3.png" />
				</a-list-item-meta>
				{{ item.intro }}
			</a-list-item>
		</a-list>
		
		
		<a-modal width="840px" :title="menu" :visible="addCompanyStyleWindow" :confirmLoading="addCompanyStyleLoading" @cancel="addCompanyStyleCancel" footer=''>
			<a-form :form="form" @submit="handleSubmit">
				<a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 8 }" label="商会创业互助标题">
					<a-input v-decorator="['title', { rules: [{ required: true, message: '请输入商会创业互助标题' }] }]" placeholder="请输入商会创业互助标题" />
				</a-form-item>
				<a-form-item  :label-col="{ span: 4 }" :wrapper-col="{ span: 8 }" label="封面">
					<a-upload
						:action="domain"
						:data="QiniuData"
						:beforeUpload="beforeUpload"
						listType="picture-card"
						:fileList="bannerList"
						:remove="bannerRemove"
						@preview="handlePreview"
					>
						<div v-if="bannerList.length < 1">
							<a-icon type="plus" />
							<div class="ant-upload-text">封面</div>
						</div>
					</a-upload>
				</a-form-item>
				<a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 15 }" label="商会创业互助简介">
					<a-textarea 
						v-decorator="['intro', { rules: [{ required: true, message: '请输入商会创业互助简介' }] }]"
						placeholder="请输入商会创业互助简介" :rows="7" />
				</a-form-item>
				
				<a-form-item :wrapper-col="{ span: 12, offset: 5 }">
					<a-button type="primary" html-type="submit">
						保存
					</a-button>
				</a-form-item>
			</a-form>
		</a-modal>
	</div>
</template>

<script>
	import E from 'wangeditor';
	import axios from 'axios'
	import api from '../../api/Api.js';
	export default {
		 name: "WriteArticle",
		data() {
			return { 
				Title:'',
				Content:'',
				editInput:'123123123',
				menu: '商会创业互助',
				addCompanyStyleWindow: false,
				addCompanyStyleLoading: false,
				form: this.$form.createForm(this, { name: 'dynamic_rule' }),
				imageUrl: '',
				QiniuData: {
					key: "", //图片名字处理
					token: "" //七牛云token
				},
				domain: "https://upload-z2.qiniup.com", // 七牛云的上传地址（华南区）
				qiniuaddr: "http://cdn.diqwl.com", // 七牛云的图片外链地址
				pictureAddress: '',
				bannerList: [],
				page:0,
				helpList:[],
				pagination: {
					onChange: page => {
						console.log(page);
					},
					pageSize: 5
				}
			};
		},
		mounted() {
			this.getQiniuToken()
			this.getHelpList()
		},
		methods: {
			handleSubmit (e) {
				const that = this;
						
				this.$confirm({
					title: '确定保存吗？',
					content: '点击保存之后，您的数据将会即刻更改，谨慎操作！',
					onOk() {
						if (that.checkUrl()) {
							this.$message.error('图片信息不完善！');
							return;
						}
						const bannerList = [];
						that.bannerList.forEach((item, index, array) => {
							bannerList.push(item.url);
						});
						
						e.preventDefault();
						that.form.validateFields((err, values) => {
							if (!err) {
								values.establishDate = that.establishDate;
								that.data = {
									title:values.title,
									img: bannerList,
									content: values.intro
								};
								that.addDynamic();
							}
						
							return new Promise((resolve, reject) => {
								setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
							}).catch(() => console.log('Oops errors!'));
						});
					},
					onCancel() {
						that.$message.warning('你点击了取消');
					}
				});
			},
			addDynamic(){
				
				var that = this;
				
				let url = 'api/commerce/v1/admin/addHelp';
				let parm = this.data;
			
				api.postRequest(url, parm, res => {
					const rest = res.data;
					if (rest.status == 200) {
						
						that.addCompanyStyleWindow = false;
						that.getHelpList();
						that.resetForm();
						this.$message.success('添加成功！');
					} else {
						this.$message.error('服务器内部错误！');
					}
				});
			},
			getHelpList(){
				const that = this;
				let url = 'api/commerce/v1/admin/helpList';
				let parm = {
					page: this.page
				};
						
				api.postRequest(url, parm, res => {
					console.log(res);
						
					const rest = res.data;
					if (rest.status == 200) {
						
						that.helpList = rest.data;
						console.log("=====================")
						console.log(that.helpList)
						console.log("=====================")
						
					} else {
						this.$message.error('服务器内部错误！');
					}
				});
				
			},
			resetForm() {
				
				this.form.resetFields();
				
				this.bannerList = []
			},
			checkUrl() {
				if (this.bannerList.length == 0) {
					return true;
				}
				return false;
			},
			bannerRemove(file) {
				var index = this.bannerList.findIndex(item => {
					if (item.uid == file.uid) {
						return true;
					}
				});
				this.bannerList.splice(index, 1);
			},
			showAddStyleModal(){
				this.addCompanyStyleWindow = true;
			},
			showCommodityModal(item) {
				this.addCompanyStyleWindow = true;
			},
			addCommodityOk() {
				console.log(this.form.getFieldsValue());
				this.form.validateFields(err => {
					if (!err) {
						console.info('success');
					} else {
						return;
					}
				});
				this.ModalText = 'The modal will be closed after two seconds';
				this.addMenuLoading = true;
				setTimeout(() => {
					this.addCompanyStyleWindow = false;
					this.addCompanyStyleLoading = false;
				}, 1000);
			},
			addCompanyStyleCancel() {
				this.addCompanyStyleWindow = false;
			},
			commodityMoney(value) {
				console.log(value);
			},
			handleChange(info) {
				if (info.file.status === 'uploading') {
					this.loading = true;
					return;
				}
				if (info.file.status === 'done') {
					// Get this url from response in real world.
					getBase64(info.file.originFileObj, imageUrl => {
						this.imageUrl = imageUrl;
						this.loading = false;
					});
				}
			},
			beforeUpload(file) {
				const isPNG = file.type === "image/png";
				const isJPEG = file.type === "image/jpeg";
				const isJPG = file.type === "image/jpg";
				const isLt2M = file.size / 1024 / 1024 < 2;
						
				if (!isPNG && !isJPEG && !isJPG) {
				  this.$message.error("上传头像图片只能是 jpg、png、jpeg 格式!");
				  return false;
				}
				if (!isLt2M) {
				  this.$message.error("上传头像图片大小不能超过 2MB!");
				  return false;
				}
				this.QiniuData.key = `store_banner_${file.name}`;
				this.pictureAddress = this.qiniuaddr +"/"+ this.QiniuData.key;
				
				var obj = {
					status: 'done'
				};
				obj.uid = file.uid;
				obj.name = this.QiniuData.key;
				obj.url = this.pictureAddress;
				this.bannerList.push(obj)
			},
			handlePreview(file) {
				this.previewImage = file.url || file.thumbUrl;
				this.previewVisible = true;
			},
			deleteDynamic(id){
				const that = this;
				let url = 'api/commerce/v1/admin/deleteHelp';
				let parm = {
					id: id
				};
				api.postRequest(url, parm, res => {
					const rest = res.data;
					if (rest.status == 200) {
						this.$message.success('删除成功！');
						that.getHelpList()
					} else {
						this.$message.error('服务器内部错误！');
					}
				});
			},
			cancel(){
				
			},
			//请求后台拿七牛云token
			getQiniuToken() {
				axios({
					method: 'post',
					url: '/api/file/v1/qiniu/getToken',
					data: JSON.stringify({
						param: '1'
					}),
					headers: {
						"authCode":'GJaImrLgzbgKQ0GaNX5kgCDtPrk7mcdF6Kq2zxe62pU=',
						'Content-Type': 'application/json',
						token: localStorage.getItem('accessToken'),
						"device": 'admin'
					}
				}).then(res => {
					if (res.data.status == 200) {
						this.QiniuData.token = res.data.data.token;
					} else {
						this.$message.error('服务器内部错误');
					}
				});
			},
		}
	};
</script>

<style>
	.banner-title {
		border-bottom: 2px solid gray;
		margin-bottom: 30px;
		margin-top: 10px;
	}
	.preview_phone {
		width: 670px;
		height: 670px;
		background-image: url('../../static/phone.png');
		background-size: 100%;
	}
</style>
